require('../../modules/es6.string.from-code-point');
module.exports = require('../../modules/_core').String.fromCodePoint;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/fn/string/from-code-point.js
// module id = 386
// module chunks = 0 1